<template>
  <div
    class="collapse-block"
    :class="{'is_transparent': transparent}"
    :style="`--color-collapse: ${color}`">
    <div
      class="collapse-block__title"
      :style="`--color-collapse: ${color}`"
      @click="change">
      <slot
        name="title"
        :show="valueMutable"/>
    </div>
    <transition
      name="s-zoom-in-top">
      <div
        class="collapse-block__content"
        :class="{'show': valueMutable}">
        <slot
          :show="valueMutable"/>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'CollapseBlock',
  methods: {
    change() {
      if (this.hideArrow) { return }
      this.valueMutable = !this.valueMutable
    },
  },
  computed: {
    valueMutable: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  mounted() {
    this.show = this.value
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'var(--green_chosen_light)'
    },
    transparent: {
      type: Boolean
    }
  },
}
</script>
<style scoped lang="scss">
.collapse-block {
  $block: &;
  border-radius: 10px;
  border-color: var(--color-collapse);
  background: var(--v-main__light_green-base);
  border-width: 2px;
  border-style: solid;
  &.is_transparent {
    border-color: transparent;
    background: transparent;
    border-radius: 0;
    border-width: 0;
    #{$block}__title {
      background: transparent;
      padding: 0;
      min-height: 20px;
    }
    #{$block}__content {
      padding: 0;
    }
  }
  &__title {
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    min-height: 40px;
    background: var(--color-collapse);
    padding: 0px 0px 0px 12px;
  }
  &__content {
    max-height: 0;
    overflow: hidden;
    transition: all 0.25s;
    &.show {
      padding: 12px 8px 8px 24px;
      max-height: 2000px;
      overflow: visible;
    }
  }
}
</style>
